"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewCalculatorInbound extends new_item_1.default {
    constructor(newCalculatorInbound) {
        super();
        this.emailAddress = newCalculatorInbound.emailAddress;
        this.googlePlacesId = newCalculatorInbound.googlePlacesId;
        this.businessName = newCalculatorInbound.businessName;
    }
}
exports.default = NewCalculatorInbound;
//# sourceMappingURL=new-calculatorInbound.js.map